import { __assign, __read, __spreadArray } from "tslib";
import React, { Fragment, useEffect, useRef, useState, useCallback, useLayoutEffect } from 'react';
import classNames from 'classnames';
import isObject from 'isobject';
import { useDefaultValue } from '@tencent/tea-component/lib/form/controlled';
import i18n from '../i18n';
var t = i18n.t;
export function BuyCompare(props) {
    var isMulti = props.options.length > 4;
    var _a = __read(useState(0), 2), scrollLeft = _a[0], setScrollLeft = _a[1];
    var _b = __read(useState(undefined), 2), maxScrollLeft = _b[0], setMaxScrollLeft = _b[1];
    var containerRef = useCallback(function (node) {
        if (node === null) {
            return;
        }
        var scrollContainerWidth = node.clientWidth;
        var scrollContentWidth = node.querySelector('.buy-compare__multi-table-ref').clientWidth;
        setMaxScrollLeft(scrollContentWidth - scrollContainerWidth);
    }, []);
    if (isMulti) {
        return (React.createElement("div", { className: classNames('buy-compare__multi', {
                'buy-compare__multi-container': scrollLeft !== maxScrollLeft,
                'buy-compare__multi-container-border__remove': scrollLeft === maxScrollLeft,
            }), onScroll: function (e) {
                setScrollLeft(e.target.scrollLeft);
            }, ref: containerRef },
            React.createElement("div", { className: "buy-compare__multi-border__right", style: {
                    right: -scrollLeft,
                } }),
            React.createElement("table", { className: "buy-compare__multi-table-ref" },
                React.createElement(BuyCompareTbody, __assign({}, props)))));
    }
    return (React.createElement("div", { className: "buy-compare" },
        React.createElement("table", null,
            React.createElement(BuyCompareTbody, __assign({}, props)))));
}
export function BuyCompareTbody(props) {
    var _a = useDefaultValue(props, ''), value = _a.value, headers = _a.headers, options = _a.options, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, foldRows = _a.foldRows, _c = _a.defaultFold, defaultFold = _c === void 0 ? true : _c;
    var tbodyRef = useRef(null);
    var renderDataRef = useRef(null);
    var isMulti = options.length > 4;
    var _d = __read(useState(defaultFold), 2), fold = _d[0], setFold = _d[1];
    var _e = __read(useState({
        renderHeaders: headers,
        renderOptions: options,
    }), 2), renderData = _e[0], setRenderData = _e[1];
    var classNamePrefix = isMulti ? 'buy-compare__multi' : 'buy-compare';
    // foldRows 存在时 headers options foldRows 改变时重置 renderData 重新计算
    useEffect(function () {
        if (!foldRows) {
            // 直接修改
            setRenderData({ renderHeaders: headers, renderOptions: options });
            return;
        }
        renderDataRef.current = null;
    }, [headers, options, foldRows]);
    useEffect(function () {
        if (foldRows) {
            Array.from(tbodyRef.current.querySelectorAll("." + classNamePrefix + "-row__deep")).forEach(function (tr) {
                tr.style.minHeight = '46px';
            });
        }
    }, [fold]);
    useEffect(function () {
        if (!foldRows) {
            return;
        }
        if (fold) {
            // current 中存在值时  直接从中取值  避免二次计算
            if (renderDataRef.current) {
                setRenderData(__assign({}, renderDataRef.current));
            }
            else {
                var _a = __read(transformFold(headers, options, foldRows), 2), renderHeaders_1 = _a[0], renderOptions_1 = _a[1];
                renderDataRef.current = { renderHeaders: renderHeaders_1, renderOptions: renderOptions_1 };
                setRenderData({ renderHeaders: renderHeaders_1, renderOptions: renderOptions_1 });
            }
        }
        else {
            setRenderData({ renderHeaders: headers, renderOptions: options });
        }
    }, [headers, options, foldRows, fold]);
    useEffect(function () {
        var _a;
        var activeIndex = (_a = options.findIndex(function (v) { return v.value === value; })) !== null && _a !== void 0 ? _a : 0;
        setActiveIndex(activeIndex);
    }, [options, value]);
    var renderHeaders = renderData.renderHeaders, renderOptions = renderData.renderOptions;
    var headerHeight = useHeaderHight({ tbodyRef: tbodyRef, options: renderOptions });
    var heightMatrix = useHeightMatrix({ tbodyRef: tbodyRef, headers: renderHeaders, options: renderOptions });
    var initialActiveIndex = renderOptions.findIndex(function (_a) {
        var optionValue = _a.value, disabled = _a.disabled;
        return optionValue === value && !disabled;
    });
    var _f = __read(useState(initialActiveIndex === -1 ? undefined : initialActiveIndex), 2), activeIndex = _f[0], setActiveIndex = _f[1];
    var _g = __read(useState(undefined), 2), hoverIndex = _g[0], setHoverIndex = _g[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("tbody", { ref: tbodyRef, className: classNames({ 'buy-compare__multi-tbody': isMulti }) },
            React.createElement("tr", null,
                React.createElement(BuyCompareHeader, __assign({}, props, { headers: renderHeaders, isMulti: isMulti, heightMatrix: heightMatrix, headerHeight: headerHeight })),
                renderOptions.map(function (option, index) { return (React.createElement(BuyCompareOption, __assign({}, option, { key: index, index: index, active: option.value === value, onClick: function (event) {
                        if (!option.disabled) {
                            onChange(option.value, { event: event });
                        }
                    }, headers: headers, isMulti: isMulti, headerHeight: headerHeight, heightMatrix: heightMatrix, onMouseEnter: function () { return !option.disabled && setHoverIndex(index); }, onMouseLeave: function () { return !option.disabled && setHoverIndex(undefined); }, hoverIndex: hoverIndex, activeIndex: activeIndex }))); }))),
        !!foldRows && (React.createElement("tfoot", null,
            React.createElement("tr", null,
                React.createElement("td", { colSpan: options.length + 1 },
                    React.createElement("div", { className: "buy-compare-expand", onClick: function () { return setFold(!fold); } },
                        React.createElement("span", null, fold ? t('展开') : t('收起')),
                        React.createElement("i", { className: classNames('buy-icon', { 'tea-icon-arrowup': !fold, 'tea-icon-arrowdown': fold }) }))))))));
}
function BuyCompareHeader(_a) {
    var headers = _a.headers, isMulti = _a.isMulti, headerHeight = _a.headerHeight, heightMatrix = _a.heightMatrix;
    var classNamePrefix = isMulti ? 'buy-compare__multi' : 'buy-compare';
    var getHeaderChildHeight = function (index, childIndex) {
        if (!heightMatrix)
            return undefined;
        var start = 0;
        for (var i = 0; i < index; i++) {
            start += headers[i].children.length;
        }
        return heightMatrix[1][start + childIndex];
    };
    var hasTitle = headers.some(function (header) { return Object.keys(header).includes('title'); });
    return (React.createElement("td", { className: classNames(classNamePrefix + "-title", { 'buy-compare__multi-title__scroll': isMulti }) },
        React.createElement("table", { className: classNamePrefix + "-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { display: "" + (hasTitle ? '' : 'none'), height: headerHeight !== null && headerHeight !== void 0 ? headerHeight : 'atuto' } }),
                    React.createElement("th", { style: { height: headerHeight !== null && headerHeight !== void 0 ? headerHeight : 'atuto' }, className: classNamePrefix + "-head-item" }, t('对比项')))),
            React.createElement("tbody", null, headers.map(function (_a, index) {
                var _b;
                var title = _a.title, children = _a.children;
                return (React.createElement(Fragment, { key: index },
                    React.createElement("tr", { style: { display: "" + (title ? '' : 'none') } },
                        React.createElement("td", { className: classNames(classNamePrefix + "-head", (_b = {},
                                _b[classNamePrefix + "-row__deep"] = index % 2 === 0,
                                _b)), rowSpan: children.length + 1 },
                            React.createElement("span", null, title))),
                    children.map(function (child, childIndex) {
                        var _a;
                        var _b;
                        return (React.createElement("tr", { key: childIndex, className: classNames((_a = {},
                                _a[classNamePrefix + "-row__deep"] = index % 2 === 0,
                                _a)), style: { height: (_b = getHeaderChildHeight(index, childIndex)) !== null && _b !== void 0 ? _b : 'auto' } },
                            React.createElement("td", { className: classNamePrefix + "-head-item" },
                                React.createElement("span", null, child))));
                    })));
            })))));
}
function BuyCompareOption(_a) {
    var _b;
    var title = _a.title, subtitle = _a.subtitle, rows = _a.rows, _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, index = _a.index, headers = _a.headers, isMulti = _a.isMulti, headerHeight = _a.headerHeight, heightMatrix = _a.heightMatrix, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, hoverIndex = _a.hoverIndex, _e = _a.disabled, disabled = _e === void 0 ? false : _e, activeIndex = _a.activeIndex;
    var classNamePrefix = isMulti ? 'buy-compare__multi' : 'buy-compare';
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var row__deep_list = headers.reduce(function (prev, _a, index) {
        var children = _a.children;
        // eslint-disable-next-line no-param-reassign
        prev = __spreadArray(__spreadArray([], __read(prev)), __read(new Array(children.length).fill(index % 2 === 0)));
        return prev;
    }, []);
    var isHover = index === hoverIndex;
    return (React.createElement("td", { className: classNames(classNamePrefix + "-item", (_b = {
                'is-active': active,
                'is-disabled': disabled
            },
            _b[classNamePrefix + "-item_first"] = index === 0,
            _b[classNamePrefix + "-border__left__remove"] = activeIndex !== undefined
                && hoverIndex !== undefined
                && ((hoverIndex === activeIndex + 1 && isHover) || (hoverIndex === activeIndex - 1 && active)),
            _b)), onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement("table", { className: classNamePrefix + "-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { height: headerHeight !== null && headerHeight !== void 0 ? headerHeight : 'atuto' }, className: classNames({
                            'buy-compare__multi-table-head': isMulti,
                        }) },
                        React.createElement("div", { className: classNamePrefix + "-version" }, title),
                        React.createElement("div", { className: classNamePrefix + "-version-desc" }, subtitle)))),
            React.createElement("tbody", { className: classNamePrefix + "-table-body" }, rows.map(function (row, rowIndex) {
                var _a;
                var _b, _c;
                var rowIsObject = isObject(row) && !React.isValidElement(row);
                var alignType = rowIsObject ? row.align : undefined;
                return (React.createElement("tr", { key: rowIndex, className: classNames(classNamePrefix + "-table-body-row", (_a = {},
                        _a[classNamePrefix + "-row__deep"] = row__deep_list[rowIndex],
                        _a[classNamePrefix + "-row__list"] = Array.isArray(row),
                        _a)), style: { height: (_c = (_b = heightMatrix === null || heightMatrix === void 0 ? void 0 : heightMatrix[index + 2]) === null || _b === void 0 ? void 0 : _b[rowIndex]) !== null && _c !== void 0 ? _c : 'auto' } },
                    React.createElement("td", { align: alignType }, row === true ? (React.createElement("i", { className: "buy-icon buy-icon-right" })) : row === false ? ('/') : Array.isArray(row) ? (React.createElement("ul", { className: classNamePrefix + "-list" }, row.map(function (item, index) { return (React.createElement("li", { key: index }, item)); }))) : rowIsObject ? (row.text) : (row))));
            })))));
}
function useHeightMatrix(_a) {
    var tbodyRef = _a.tbodyRef, headers = _a.headers, options = _a.options;
    var _b = __read(useState(undefined), 2), heightMatrix = _b[0], setHeightMatrix = _b[1];
    // const optionsRef = useRef<null | BuyCompareOptionProps[] | null>(null);
    // const heightMatrixRef = useRef<number[][] | undefined>(undefined);
    useEffect(function () {
        // todo 当option改变时 需要重新计算高度，所以在effect上添加options依赖，（options长度不改变内容改变时， 之前并不会触发effect）
        if (!options) {
            return;
        }
        // 获取所有 td 的高度
        var heightList = Array.from(tbodyRef.current.querySelectorAll('td tbody td')).map(function (node) { return node.clientHeight; });
        // 将获取高度生成一个矩阵
        var heightMatrix = [[], []];
        headers.forEach(function (_a) {
            var children = _a.children;
            heightMatrix[0].push(heightList.shift());
            /* eslint-disable-next-line @typescript-eslint/prefer-for-of */
            for (var i = 0; i < children.length; i++) {
                heightMatrix[1].push(heightList.shift());
            }
        });
        options.forEach(function (_a, index) {
            var rows = _a.rows;
            heightMatrix[index + 2] = [];
            rows.forEach(function () {
                heightMatrix[index + 2].push(heightList.shift());
            });
        });
        // 重新分配高度，先将选项的高度每一行取最大值
        for (var i = 1; i < heightMatrix.length; i++) {
            var _loop_1 = function (j) {
                heightMatrix[i][j] = Math.max.apply(null, heightMatrix.slice(1).map(function (numbers) { return numbers[j]; }));
            };
            for (var j = 0; j < heightMatrix[i].length; j++) {
                _loop_1(j);
            }
        }
        // 遍历 heightMatrix[0]，若高度大于后面的选项高度，则重新配置选项高度，反之，不用处理
        for (var i = 0, j = 0, k = 0; i < headers.length; i++) {
            var headerHeight = heightMatrix[0][i];
            // 初始值为 -1 是因为去掉后面多加的一个 border
            var optionsHeight = -1;
            for (k = 0; k < headers[i].children.length; k++) {
                // 这里 +1 是因为需要加上 border
                optionsHeight += heightMatrix[1][j + k] + 1;
            }
            // 若高度大于后面的选项高度，则重新配置选项高度
            if (headerHeight > optionsHeight) {
                for (var a = 1; a < heightMatrix.length; a++) {
                    for (var b = 0; b < headers[i].children.length; b++) {
                        heightMatrix[a][j + b] += (headerHeight - optionsHeight) / headers[i].children.length;
                    }
                }
            }
            j += k;
        }
        // 由于需要设置高度给 tr，所以每一项都 +1
        for (var i = 1; i < heightMatrix.length; i++) {
            for (var j = 0; j < heightMatrix[i].length; j++) {
                heightMatrix[i][j] += 1;
            }
        }
        setHeightMatrix(heightMatrix);
    }, [tbodyRef, options]);
    return heightMatrix;
}
/** 计算thead th高度  统一高度 */
function useHeaderHight(_a) {
    var tbodyRef = _a.tbodyRef, options = _a.options;
    var _b = __read(useState(undefined), 2), headerHeight = _b[0], setHeaderHeight = _b[1];
    useLayoutEffect(function () {
        var _a;
        var list = Array.from((_a = tbodyRef === null || tbodyRef === void 0 ? void 0 : tbodyRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('td thead th'));
        var hightCopyList = [];
        list.forEach(function (v) {
            hightCopyList.push(v.style.height);
            v.style.height = 'auto';
        });
        var heightList = list.map(function (node) { return node.clientHeight; });
        list.forEach(function (v, index) {
            v.style.height = hightCopyList[index];
        });
        setHeaderHeight(Math.max.apply(Math, __spreadArray([], __read(heightList))));
    }, [tbodyRef, options]);
    return headerHeight;
}
function transformFold(headers, options, foldRows) {
    var rowsLen = options[0].rows.length;
    if (foldRows > rowsLen) {
        return [headers, options];
    }
    var current = rowsLen - foldRows;
    var flodHeaders = headers
        .map(function (j) { return (__assign(__assign({}, j), { children: j.children.filter(function () {
            if (current > 0) {
                current -= 1;
                return true;
            }
            return false;
        }) })); })
        .filter(function (k) { return !!k.children.length; });
    var flodOptions = options.map(function (v) { return (__assign(__assign({}, v), { rows: v.rows.slice(0, -foldRows) })); });
    return [flodHeaders, flodOptions];
}
//# sourceMappingURL=BuyCompare.js.map